<!-- Encoder Record Queue -->
<div class="encoder-list">
  <div class="encoder" *ngFor="let recordQueue of encoderRecordQueue; let index = index">
    <div class="title" *ngIf="encoderRecordQueue.length > 1">E{{ index + 1 }}</div>
    <div class="frames-info">{{ recordQueue.numQueuedEnc }}/{{ recordQueue.numQueuedWrite }}</div>
  </div>
</div>
